import React from 'react';
import { styled } from '@nykaa/ui-components';
import { getStrokeColor } from 'components/Header/helper';

interface HamburgerProps {
  isLight: boolean;
  color?: string;
}

const Icon = styled.svg<{ isLight: boolean; color?: string }>`
  ${({ theme, isLight, color }) => `
    g {
      stroke: ${getStrokeColor(theme, isLight, color)};
    }
  `};
`;
function Hamburger({ isLight, color }: HamburgerProps) {
  return (
    <Icon
      isLight={isLight}
      color={color}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>ic-left-nav</title>
      <g
        id="ic-left-nav"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="ic_hamburger"
          transform="translate(3.000000, 6.000000)"
          stroke="#000000"
          strokeWidth="1.5"
        >
          <line
            x1="0.5"
            y1="0.53"
            x2="17.5"
            y2="0.53"
            id="Path"
          ></line>
          <line
            x1="0.5"
            y1="11.47"
            x2="17.5"
            y2="11.47"
            id="Path"
          ></line>
          <line
            x1="0.5"
            y1="6.04"
            x2="17.5"
            y2="6.04"
            id="Path"
          ></line>
        </g>
      </g>
    </Icon>
  );
}

export default Hamburger;
